module.exports = __webpack_public_path__ + "static/media/partner_shunfengsuyun.382aa7b6.png";